import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

@Injectable()
export class MatPaginatorIntlCustom extends MatPaginatorIntl {

  override getRangeLabel = (page: number, pageSize: number, length: number) => {
    return 'item ' + (page + 1) + ' van de ' + length;
  };
}
